<template>
    <div v-if="project">
        <div class="relative w-full h-screen bg-white">
            <!-- Title -->
            <div
                class="relative z-10 flex items-end justify-center w-full h-full px-12 text-white md:px-0 md:items-center md:mix-blend-difference"
            >
                <h1
                    ref="headTitle"
                    class="relative font-display text-7xl lg:text-[12rem] uppercase tracking-tight xl:text-center"
                    style="
                        -webkit-hyphens: auto;
                        -ms-hyphens: auto;
                        hyphens: auto;
                        font-variant-ligatures: none;
                    "
                >
                    {{ title }}
                </h1>
            </div>
            <div
                data-speed="0.75"
                class="absolute top-0 left-0 z-10 items-start justify-center hidden w-screen h-screen pt-12 text-white md:mix-blend-difference sm:flex"
            >
                <h4 ref="headCategories" class="text-lg uppercase">
                    {{ categoriesList }}
                </h4>
            </div>
            <!-- Background -->
            <div
                ref="headBg"
                class="absolute h-screen w-full xl:w-[550px] left-1/2 top-2 md:-top-24 transform -translate-x-1/2 z-0"
            >
                <div
                    data-speed="0.75"
                    class="relative bg-primary w-full h-screen md:h-[125%]"
                >
                    <!-- <img
                        v-if="image"
                        class="object-cover w-full h-full brightness-50 md:brightness-100"
                        :src="image"
                        alt=""
                    /> -->
                </div>
            </div>
        </div>

        <!-- Info Section -->
        <ProjectsInfoSection
            :project="project"
            :categories-list="categoriesList"
        />
        <!-- END > Info Section -->

        <!-- Content section -->
        <section class="relative my-32 md:my-48">
            <!-- Section Panorama photo -->
            <div
                class="overflow-hidden relative w-full md:h-[650px] z-10 flex justify-end"
            >
                <div
                    class="overflow-hidden inline-block relative w-full h-[550px] md:h-[850px]"
                >
                    <div class="w-full h-full">
                        <img
                            data-speed="0.65"
                            :src="image"
                            class="object-cover w-full h-full bg-gray-600 md:absolute -top-36"
                        />
                    </div>
                </div>
            </div>
            <!-- END > Section Panorama photo -->

            <!-- Section Image carousel -->
            <div class="container mt-16 sm:mt-24">
                <div
                    v-if="project.imageCarousel[0]"
                    class="grid grid-cols-1 gap-0 md:grid-cols-12 md:gap-x-14"
                >
                    <div class="col-span-8">
                        <div class="inline-block w-full h-full">
                            <img
                                class="w-full object-cover h-full max-h-[650px] rounded-lg"
                                :src="`${runtimeConfig.public.contentApiUrl}/assets/${project.imageCarousel[0].directus_files_id}?width=960&height=620&quality=90&format=webp`"
                                alt=""
                            />
                        </div>
                    </div>
                    <div
                        class="grid col-span-4 mt-8 md:mt-0 gap-y-8 md:gap-y-14"
                    >
                        <div
                            v-if="project.imageCarousel[1]"
                            class="inline-block w-full"
                        >
                            <img
                                class="w-full h-full object-cover max-h-[300px] rounded-lg"
                                :src="`${runtimeConfig.public.contentApiUrl}/assets/${project.imageCarousel[1].directus_files_id}?width=460&height=300&quality=90&format=webp`"
                                alt=""
                            />
                        </div>
                        <div
                            v-if="project.imageCarousel[2]"
                            class="inline-block w-full"
                        >
                            <img
                                class="w-full h-full object-cover max-h-[350px] rounded-lg"
                                :src="`${runtimeConfig.public.contentApiUrl}/assets/${project.imageCarousel[2].directus_files_id}?width=460&height=300&quality=90&format=webp`"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
                <!-- END > Section Image carousel -->

                <!-- Section TEXT1 -->
                <section class="my-48 space-y-16 md:ml-12">
                    <div>
                        <h2
                            data-animation="FADE_UP"
                            v-if="project.heading1"
                            class="text-3xl font-bold"
                        >
                            {{ project.heading1 }}
                        </h2>
                        <ParagraphComponent
                            data-animation="FADE_UP"
                            v-if="project.text1"
                            class="max-w-3xl mt-8"
                            :text="project.text1"
                        />
                    </div>
                    <ProjectsImageGrid
                        :image1="project.imagesTxt1[0]"
                        :image2="project.imagesTxt1[1]"
                        :image3="project.imagesTxt1[2]"
                    />
                </section>

                <!-- Section TEXT2 -->
                <section class="my-48 space-y-16 md:ml-12">
                    <div>
                        <h2
                            v-if="project.heading2"
                            data-animation="FADE_UP"
                            class="text-3xl font-bold"
                        >
                            {{ project.heading2 }}
                        </h2>
                        <ParagraphComponent
                            v-if="project.text2"
                            data-animation="FADE_UP"
                            class="max-w-3xl mt-8"
                            :text="project.text2"
                        />
                    </div>
                    <ProjectsImageGrid
                        :image1="project.imagesTxt2[0]"
                        :image2="project.imagesTxt2[1]"
                        :image3="project.imagesTxt2[2]"
                    />
                </section>

                <!-- <div
                    v-if="project.text1"
                    data-scroll
                    data-scroll-class="FADE_UP"
                    class="grid-cols-2 my-24 md:grid md:my-44"
                >
                    <div></div>
                    <div>
                        <ParagraphComponent
                            class="max-w-[550px]"
                            :text="project.text1"
                        />
                    </div>
                </div> -->
                <!-- TODO VIDEO -->
                <!-- <div v-if="video">
                    <iframe
                        :src="video"
                        width="100%"
                        height="450px"
                        frameborder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowfullscreen
                        title="Rebound University Project"
                    ></iframe>
                </div> -->
                <!-- <div class="grid-cols-2 my-24 md:grid md:px-28 md:my-44">
                    <div
                        v-if="project.text2"
                        data-scroll
                        data-scroll-class="FADE_UP"
                    >
                        <ParagraphComponent
                            class="max-w-[550px]"
                            :text="project.text2"
                        />
                    </div>
                    <div
                        v-if="project.text3"
                        data-scroll
                        data-scroll-class="FADE_UP"
                        class="mt-14 md:mt-0"
                    >
                        <ParagraphComponent
                            class="max-w-[550px]"
                            :text="project.text3"
                        />
                    </div>
                </div> -->
            </div>
        </section>
        <!-- END > Content section -->
    </div>
</template>

<script setup lang="ts">
import type { IDirectusProjectResponse } from '@/types/projects';
import { useChangeCase } from '@vueuse/integrations/useChangeCase';

// Config
const runtimeConfig = useRuntimeConfig();
const projectId = useRoute().params.id;

// Fetch
const { data, status } = await useAsyncData<IDirectusProjectResponse>(
    'project',
    () =>
        $fetch(
            `${runtimeConfig.public.contentApiUrl}/items/rb_portfolio_projects/${projectId}?fields=*,imageCarousel.*,imagesTxt1.*,imagesTxt2.*,imagesTxt3.*`,
        ),
);

// Computed
const project = computed(() => {
    return data.value?.data;
});
const title = computed(() => {
    return useChangeCase(project.value?.title || '', 'capitalCase');
});
const image = computed(() => {
    return `${runtimeConfig.public.contentApiUrl}/assets/${project.value?.image}?quality=90&format=webp`;
});
const categoriesList = computed(() => {
    return project.value?.categories
        .map((category) => category.trim())
        .join(', ');
});

// Hooks
// Meta
useServerSeoMeta({
    title: title.value,
    robots: 'index, follow',
});
// Throw 404 when project could not be found
if (status.value === 'error') {
    throw createError({
        statusCode: 404,
        statusMessage: 'Not Found',
    });
}
</script>

<!-- <script lang="ts">
import config from '@/nuxt.config';

export default defineNuxtComponent({
    name: 'ProjectPage',
    async asyncData({ $axios, params, error, $sentry }) {
        const id = params.id;

        if (id.length <= 1) {
            const project = false;
            return { project };
        }

        // Get Project
        let project;
        try {
            const res = await $axios.get(
                `${process.env.CONTENT_API_URL}items/rb_portfolio_projects/${id}?fields=*,imageCarousel.*,imagesTxt1.*,imagesTxt2.*,imagesTxt3.*`,
            );

            project = res.data.data;
        } catch (err) {
            $sentry.captureException(new Error('Fetch project data error'));
            error({ statusCode: 404, message: 'Project not found' });
        }

        if (!config.dev) {
            if (!project) {
                error({ statusCode: 404, message: 'Project not found' });
                return { id, project };
            }

            if (project?.status === 'draft' || project?.status === 'archived')
                error({ statusCode: 404, message: 'Project not found' });
        }

        return { id, project };
    },
    data() {
        return {
            id: '',
            anime: {} as any,
            image: '',
            video: '',
        };
    },
    head() {
        return {
            title:
                (this as any).title().charAt(0).toUpperCase() +
                (this as any).title().slice(1),
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: (this as any).project.introTxt,
                },
            ],
        };
    },
    mounted() {
        this.anime = (this as any).$anime;
        this.animateHead();

        // Set Image
        this.image = `https://content.raphaelbernhart.at/assets/${
            (this as any).project.image
        }?quality=90&format=webp`;

        // Update Locomotive Scroll
        setTimeout(() => {
            this.$nuxt.$emit('update-locomotive');
        }, 2500);
    },
    methods: {
        animateHead() {
            const ref = this.$refs.headTitle;
            const bgRef = this.$refs.headBg as HTMLElement;
            const catRef = this.$refs.headCategories as HTMLElement;

            const animation = this.anime.timeline({
                duration: 1250,
                easing: 'easeInOutQuad',
            });

            animation.add(
                {
                    targets: bgRef.childNodes[0],
                    translateY: ['100%', 0],
                    opacity: [0, 1],
                    delay(_el: any, i: number) {
                        return i * 120;
                    },
                },
                500,
            );

            animation.add(
                {
                    targets: catRef,
                    easing: 'easeOutQuad',
                    translateY: ['100%', 0],
                    opacity: [0, 1],
                },
                1500,
            );

            if (window.innerWidth > 480) {
                const letters: any = this.$letterize({
                    targets: ref,
                    className: 'inline-block',
                });

                let lastLerp = 0;

                const initialLerpDelay: number = 1.6;
                const lerpDelayAdditionPerLetter: number = parseFloat(
                    (initialLerpDelay / letters.listAll.length).toFixed(1),
                );

                // Add Lerp Effect
                letters.listAll.forEach((e: HTMLElement) => {
                    const html = e.innerHTML;
                    e.innerHTML = `<span>${html}</span>`;

                    // Add the effect
                    e.children[0].classList.add('inline-block');
                    e.children[0].setAttribute('data-scroll', '');
                    e.children[0].setAttribute('data-scroll-speed', '6');
                    e.children[0].setAttribute(
                        'data-scroll-delay',
                        (1.6 - lastLerp).toFixed(1).toString(),
                    );

                    lastLerp += lerpDelayAdditionPerLetter;
                });

                animation.add(
                    {
                        targets: letters.listAll,
                        translateY: [70, 0],
                        opacity: [0, 1],
                        easing: 'easeOutQuad',
                        duration: 1000,
                        delay(_el: any, i: number) {
                            return i * 120;
                        },
                    },
                    1000,
                );
            }

            // animation.add(
            //     {
            //         targets: ref,
            //         translateY: [250, 0],
            //         easing: 'easeOutQuad',
            //         duration: 1100,
            //     },
            //     900,
            // );
        },
        title() {
            const id = (this as any).id;
            if (id) return id.replace('-', ' ');
            return '';
        },
    },
});
</script> -->
